import * as tslib_1 from "tslib";
import { OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EEntity } from '../../enums/entity.enum';
import { EProjects } from '../../enums/projects.enum';
import { ConfigService } from '../../services/config/config.service';
import { Websocket } from '../../classes/websocket/websocket.class';
import { EWsStatus } from '../../enums/websocket-status.enum';
import wsHandlers from '../../../checkin-app/modules/inbox/pages/chat/handlers';
var ProjectsComponent = /** @class */ (function () {
    function ProjectsComponent(activatedRoute, config) {
        this.activatedRoute = activatedRoute;
        this.config = config;
        this.project = this.config.project;
        this.setHeaderConfig(this.config.screen.isLG);
        this.responsiveSubscriber();
        this.setQueryParams();
    }
    ProjectsComponent.prototype.setQueryParams = function () {
        var _this = this;
        this.activatedRoute.queryParams.subscribe(function (params) {
            _this.config.return_url = params.return_url;
        });
    };
    ProjectsComponent.prototype.setHeaderConfig = function (isResponsive) {
        this.header = {
            show: !(this.config[this.project].modules.RESPONSIVE.HIDE_HEADER) || !isResponsive
        };
    };
    ProjectsComponent.prototype.responsiveSubscriber = function () {
        var _this = this;
        Object.assign(this, {
            isResponsive: this.config.screen.isLG,
            subscriber: this.config.screen.onIsLGChanges().subscribe(function (isResponsive) {
                _this.isResponsive = isResponsive;
                _this.setHeaderConfig(isResponsive);
            })
        });
    };
    ProjectsComponent.prototype.setWebSocket = function () {
        var _this = this;
        var _a;
        var _b = this.config, _c = _b.booking, idBooking = _c.id, idClient = _c.mainOccupantId, idCompany = _c.resume.idCompany, guests = _c.guests, isDelegated = _b.checkin.delegated, project = _b.project;
        var hasInboxRoute = Array.isArray(this.config.checkin.tabs) && this.config.checkin.tabs.some(function (tab) { return tab.route === 'inbox'; });
        if (project === String(EProjects.CHECKIN) && isDelegated && !hasInboxRoute) {
            return;
        }
        var _d = this.getEntityParams(idClient, idCompany, guests, isDelegated, project), loggedInEntityId = _d.loggedInEntityId, entityId = _d.entityId, loggedInEntity = _d.loggedInEntity, entity = _d.entity;
        if (!this.config.ws) {
            this.config.ws = new Websocket((_a = {},
                _a[EWsStatus.CONNECTED] = function (send) { return wsHandlers[EWsStatus.CONNECTED]
                    .bind(_this)(send, idBooking, loggedInEntityId, entityId, loggedInEntity, entity); },
                _a[EWsStatus.RECEIVED] = function (send, res) { return wsHandlers[EWsStatus.RECEIVED](send, res); },
                _a[EWsStatus.LOAD_CONVERSATION] = function (send, res) { return wsHandlers[EWsStatus.LOAD_CONVERSATION].bind(_this)(send, res); },
                _a[EWsStatus.NEW_MESSAGE] = function (send, res) { return wsHandlers[EWsStatus.NEW_MESSAGE].bind(_this)(send, res); },
                _a[EWsStatus.STORED] = function (send, res) { return wsHandlers[EWsStatus.STORED].bind(_this)(send, res); },
                _a));
        }
    };
    ProjectsComponent.prototype.ngOnDestroy = function () {
        if (this.subscriber) {
            this.subscriber.unsubscribe();
        }
    };
    ProjectsComponent.prototype.getEntityParams = function (idClient, idCompany, guests, isDelegated, project) {
        var entityParams = {
            loggedInEntity: EEntity.CLIENT,
            loggedInEntityId: idClient,
            entity: EEntity.COMPANY,
            entityId: idCompany
        };
        if (project === String(EProjects.CHECKIN) && isDelegated) {
            var companionsList = Object.values(guests.list).filter(function (guest) { return guest.validated && (guest.delegated === guest.email); });
            if (companionsList.length > 0) {
                var idOccupant = companionsList[0].id;
                return tslib_1.__assign({}, entityParams, { loggedInEntityId: idOccupant });
            }
            var delegated = guests.list[Object.keys(guests.list)[0]].delegated;
            return {
                loggedInEntity: EEntity.OTHER,
                loggedInEntityId: delegated,
                entity: EEntity.COMPANY,
                entityId: idCompany
            };
        }
        return entityParams;
    };
    return ProjectsComponent;
}());
export { ProjectsComponent };
